import React from 'react';

// COMPONENT
export class Select extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            value : props.value,
        }
    }

    render() {
        return (
            <select className="large-select" value={this.state.value} onChange={this.props.handleSelection} name={this.props.name}>
                { this.props.options.map(option => {
                    return (<option value={option}>{ option }</option>)
                })}
            </select>        
        )
    }
}
